import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const dashboard = createReducer(
  {
    tasksStatus: {},
    metrics: {},
    comparater: null,
    brandlocation: null,
    isLoadingMetrics: false,
    callCount: 0,
    setupInfo: null,
    getsetupInfo: false,
    isLoading: false,
    error: null,
    reportData: null,
    outcome_visualization_available: null,
  },
  {
    [types.GET_TASKS_STATUS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        tasksStatus: action.tasks,
      });

      return newState;
    },
    [types.GET_TASKS_STATUS_FAIL](state) {
      const newState = Object.assign({}, state, {
        tasksStatus: {},
      });

      return newState;
    },
    [types.GET_SETUP_INFO_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        setupInfo: action.setupInfo,
        getsetupInfo: true,
      });

      return newState;
    },
    [types.GET_SETUP_INFO_FAIL](state) {
      const newState = Object.assign({}, state, {
        setupInfo: {},
        getsetupInfo: true,
      });

      return newState;
    },
    [types.GET_METRICS_START](state, action) {
      let compare = action.compare;
      let counter = state.callCount;
      return Object.assign({}, state, {
        isLoadingMetrics: true,
        callCount: counter + 1,
        ...(!compare && { metrics: {} }),
      });
    },
    [types.GET_METRICS_SUCCESS](state, action) {
      let metrics = action.metrics;
      let compare = action.compare;
      let brandlocation = action.brandlocation;
      let brandOnly = action.brandOnly;
      let counter = state.callCount;
      const newState = Object.assign({}, state, {
        ...(!(compare || brandOnly) && { metrics }),
        ...(compare && { comparater: metrics }),
        ...(brandlocation && { brandlocation: metrics }),
        ...(brandOnly && { brandlocation: metrics }),
        callCount: counter - 1,
        isLoadingMetrics: false,
      });
      return newState;
    },
    [types.GET_METRICS_FAIL](state) {
      let counter = state.callCount;
      const newState = Object.assign({}, state, {
        metrics: {},
        callCount: counter - 1,
        isLoadingMetrics: false,
      });

      return newState;
    },
    [types.GET_REPORT_DATA_START](state) {
      return { ...state, isLoading: true, error: null };
    },
    [types.GET_REPORT_DATA_SUCCESS](state, action) {
      console.log('CSV Data', action.payload);
      return { ...state, reportData: action.payload, isLoading: false };
    },
    [types.GET_REPORT_DATA_FAIL](state) {
      return { ...state, isLoading: false, error: 'Failed to fetch report data.' };
    },
    [types.GET_OUTCOME_VISUALISATION_START](state, action) {
      const newState = Object.assign({}, state, {
      });
      return newState;
    },
    [types.GET_OUTCOME_VISUALISATION_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        outcome_visualization_available: action?.data?.show_outcome_visualization,
      });
      return newState;
    },
    [types.GET_OUTCOME_VISUALISATION_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        outcome_visualization_available: false,
      });
      return newState;
    },

  },
);

export { dashboard as default };
